// extracted by mini-css-extract-plugin
export default {"link":"dWjGD7","root":"r2GiXz","label":"JX1yLo"};